module.exports = __webpack_public_path__ + "static/media/ignore-active-icon.e8092342.svg";